/* Fecha estimada de entrega. Se carga en todas las páginas (doc-head-core) y
   se ejecuta en la ficha de producto, en la compra rápida, en los productos
   destacados y cada vez que el tema repinta el bloque (cambio de variante,
   etc.): los <script> inline no se ejecutan en esos casos, por eso vive aquí y
   vigila la página. El HTML trae un texto por defecto por si el script no llega. */
(function () {
  if (window.__estDeliveryLoaded) { window.__estDeliveryRender && window.__estDeliveryRender(); return; }
  window.__estDeliveryLoaded = true;

  // ===== AJUSTA ESTO =====
  // min / max = días laborables de transporte
  // corte = hora límite lun-jue · corteViernes = hora límite viernes
  var PLAZOS = {
    DEFAULT: { min: 1, max: 2, corte: 15, corteViernes: 16 },  // España y resto
    DE:      { min: 3, max: 5, corte: 14, corteViernes: 14 },  // Alemania
    AT:      { min: 3, max: 5, corte: 14, corteViernes: 14 }   // Austria
  };
  var FESTIVOS = [
    '2026-10-12', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-01-06'
  ];
  var TEXTOS = {
    es: ['Compra ahora y recíbelo entre el ', ' y el '],
    de: ['Jetzt bestellen und erhalten zwischen dem ', ' und dem ']
  };
  // Aviso de hora límite (solo si aún se está a tiempo de que salga hoy)
  var CORTE_TEXTOS = {
    es: function (h) { return 'Pídelo antes de las ' + h + ':00 y sale hoy mismo'; },
    de: function (h) { return 'Bestelle vor ' + h + ':00 Uhr – Versand noch heute'; }
  };
  // Texto por defecto (el mismo que pone el snippet desde el servidor)
  var DEFECTO = { es: 'Recíbelo en 24-48 h laborables', de: 'Lieferung in 3–5 Werktagen' };
  // =======================

  function iso(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function isBiz(d) {
    return d.getDay() !== 0 && d.getDay() !== 6 && FESTIVOS.indexOf(iso(d)) === -1;
  }
  function addBiz(d, n) {
    d = new Date(d);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isBiz(d)) n--;
    }
    return d;
  }

  function country() {
    return (window.Shopify && window.Shopify.country) || '';
  }

  // Estilos (los mismos que lleva el snippet), por si el bloque se crea desde aquí
  function ensureStyles() {
    if (document.getElementById('est-delivery-css')) return;
    var st = document.createElement('style');
    st.id = 'est-delivery-css';
    st.textContent =
      '.est-delivery{display:flex;align-items:flex-start;gap:8px;font-size:14px;margin:12px 0;line-height:1.4}' +
      '.est-dot{width:8px;height:8px;border-radius:50%;background:#3bb54a;flex:none;margin-top:6px}' +
      '.est-cutoff{display:block;font-size:13px;opacity:.75}' +
      '.est-cutoff[hidden]{display:none}';
    document.head.appendChild(st);
  }

  // Productos destacados y otros sitios con botón de compra que no traen el bloque
  function inject() {
    document.querySelectorAll('.quantity-submit-row__submit').forEach(function (sub) {
      if (sub.querySelector('.est-delivery')) return;
      var btn = sub.querySelector('button[type="submit"]');
      if (!btn || btn.disabled) return;
      ensureStyles();
      var pais = country();
      var de = pais === 'DE' || pais === 'AT';
      var el = document.createElement('div');
      el.className = 'est-delivery';
      el.setAttribute('data-country', pais);
      el.innerHTML = '<span class="est-dot"></span><span class="est-body"><span class="est-text"></span><span class="est-cutoff" hidden></span></span>';
      el.querySelector('.est-text').textContent = de ? DEFECTO.de : DEFECTO.es;
      sub.insertBefore(el, sub.firstChild);
    });
  }

  function fill(el) {
    if (el.getAttribute('data-ready')) return;
    var textEl = el.querySelector('.est-text');
    if (!textEl) return;
    var pais = el.getAttribute('data-country');
    var P = PLAZOS[pais] || PLAZOS.DEFAULT;
    var lang = (pais === 'DE' || pais === 'AT') ? 'de'
             : (document.documentElement.lang || 'es').slice(0, 2);

    // hora actual en España, sin depender del reloj del cliente
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));

    // día en que sale el pedido según la hora de corte
    var corte = now.getDay() === 5 ? P.corteViernes : P.corte;
    var enHora = isBiz(now) && now.getHours() < corte;
    var dispatch = new Date(now);
    if (!enHora) dispatch = addBiz(now, 1);

    var f = new Intl.DateTimeFormat(lang === 'de' ? 'de-DE' : 'es-ES',
      { weekday: 'long', day: 'numeric', month: 'short' });
    var fmt = function (d) {
      var s = f.format(d);
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    var t = TEXTOS[lang] || TEXTOS.es;

    textEl.innerHTML =
      t[0] + '<strong>' + fmt(addBiz(dispatch, P.min)) + '</strong>' +
      t[1] + '<strong>' + fmt(addBiz(dispatch, P.max)) + '</strong>';

    var cutEl = el.querySelector('.est-cutoff');
    if (cutEl) {
      if (enHora) {
        cutEl.textContent = (CORTE_TEXTOS[lang] || CORTE_TEXTOS.es)(corte);
        cutEl.hidden = false;
      } else {
        cutEl.hidden = true;
      }
    }
    el.setAttribute('data-ready', '1');
  }

  function render() {
    inject();
    document.querySelectorAll('.est-delivery:not([data-ready])').forEach(fill);
  }
  window.__estDeliveryRender = render;

  render();
  document.addEventListener('DOMContentLoaded', render);
  // compra rápida
  document.addEventListener('on:quickbuy:after-open', render);
  // cualquier otro repintado del bloque (cambio de variante, secciones recargadas...)
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; render(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
